import { V2_ENDPOINT } from "@/consts";
import { authenticatedFetch } from "@/lib/authenticatedFetch";
import type { FallbackDataFetcher, FallbackFetchContext } from "../types";

interface TriggerTestResponse {
  code: number;
  message: string;
  data: {
    success: boolean;
    results?: Record<string, unknown>[];
    result?: Record<string, unknown>;
  };
}

const createBackendTestFallback = (): FallbackDataFetcher => {
  return async (ctx: FallbackFetchContext) => {
    const response = await authenticatedFetch<TriggerTestResponse>(
      `${V2_ENDPOINT}/v1/triggers/${encodeURIComponent(ctx.triggerType)}/test`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payload: ctx.triggerPayload }),
        signal: ctx.signal,
      },
    );
    if (!response.ok) return [];
    const data = await response.json();
    if (!data.data?.success) return [];
    return data.data.results ?? (data.data.result ? [data.data.result] : []);
  };
};

export const unusualWhalesNewsFallback: FallbackDataFetcher = createBackendTestFallback();
export const unusualWhalesFlowFallback: FallbackDataFetcher = createBackendTestFallback();
